module.exports = new __parcel__URL__("imdb.388b1dba.svg").toString();